import React from 'react'
import { ContentHeader } from '../../layout/Content'

function StockOutItemHeader() { return ( <ContentHeader title='Pulled-Out Items'/> ) }

export default React.memo(StockOutItemHeader)
